import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from '@angular/core';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { JoinClassNamesPipe } from '@shared/join/join-class-names.pipe';
import { CarouselAnimationComponent } from '@shared/carousel-animation/carousel-animation.component';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { TitleAndSubtitleComponent } from '@shared/title-and-subtitle/title-and-subtitle';

@Component({
    selector: 'companyid-our-team',
    imports: [
        ContentWrapperComponent,
        AssetPipe,
        NgOptimizedImage,
        CarouselAnimationComponent,
        TitleAndSubtitleComponent,
        JoinClassNamesPipe,
    ],
    templateUrl: './our-team.component.html',
    styleUrl: './our-team.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OurTeamComponent {
    public readonly slides = ['1'];
    public readonly assetPathAboutUsOurTeam = 'about-us/our-team';
    public readonly boxImages = [
        {
            name: 'vector-desk',
            className: 'tab:hidden mob:hidden',
        },
        {
            name: 'vector-tab',
            className: 'desk:hidden mob:hidden',
        },
        {
            name: 'vector-mob',
            className: 'desk:hidden tab:hidden',
        },
    ];

    public currentSlide = signal<number>(0);

    public onChangeSlide(id: number): void {
        this.currentSlide.set(id);
    }
}
